import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pbctwjfsgc: FaireBrandEntity = {
  token: "b_pbctwjfsgc",
  type: "brand",
  name: "Bubele",
  avatarUrl:
    "https://cdn.faire.com/fastly/5b3432cdb981f89f654d97ccc364db3b465fd8b4d29710d648054f4237c9b052.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/91ef8b01614518a2d43fa9c513f9aeb34ffc372231fb264650698d1ce9c51029.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5b3432cdb981f89f654d97ccc364db3b465fd8b4d29710d648054f4237c9b052.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/91ef8b01614518a2d43fa9c513f9aeb34ffc372231fb264650698d1ce9c51029.jpeg",
  location: "Liverpool, NY, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Bubele, meaning “sweet baby” was started in 2007 after having my youngest son Evan. After a very traumatic delivery that I spent a long time recovering from, I decided to go after my dreams and start my own clothing line. During recovery, I had some minor brain damage that left me thinking in simplistic terms which is when I got my best ideas!!\n\nI started designing the Bubele Bib with an attached neck roll that wicks milk away and the Wrap that swaddles newborns more easily by being stretchy and oversized. The last development was the attached loop on clothing to keep a pacifier within baby’s reach. This latest development took over and turned into a full range of mix and match sets that were so soft, and comfy and made it easier to change baby!\n\nBubele remains my own, small family-owned and operated company and began on a $0 budget with just my own fabrics and sewing machine. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:27.873Z",
    importedBy: "entity-db-cli",
  },
};
